var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserCheckM = function SvgUserCheckM(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3334 54.25V49.0833C41.3334 46.3428 40.2447 43.7144 38.3068 41.7766C36.3689 39.8387 33.7406 38.75 31 38.75H12.9167C10.1761 38.75 7.54781 39.8387 5.60994 41.7766C3.67206 43.7144 2.58337 46.3428 2.58337 49.0833V54.25",
    stroke: "#6280DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9583 28.4167C27.6653 28.4167 32.2917 23.7903 32.2917 18.0833C32.2917 12.3764 27.6653 7.75 21.9583 7.75C16.2514 7.75 11.625 12.3764 11.625 18.0833C11.625 23.7903 16.2514 28.4167 21.9583 28.4167Z",
    stroke: "#6280DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9166 28.4167L49.0833 33.5833L59.4166 23.25",
    stroke: "#6280DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserCheckM, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-check-m.4c7d54c7.svg";
export { ForwardRef as ReactComponent };